import { CalendarRange, X } from '../../lib/icons';

export const dansPeriode = (date, du, au) => {
  if (du && date < du) return false;
  if (au && date > au) return false;
  return true;
};

const cls =
  'h-10 border border-slate-300 bg-slate-50 px-2 font-data text-sm text-slate-900 outline-none transition-colors duration-150 focus:border-slate-900 focus:bg-white';

// Filtre de période réutilisable : filtrage dynamique, dates incluses.
export const PeriodeFiltre = ({ du, au, setDu, setAu, testid = 'periode', total, filtres }) => (
  <div data-testid={testid} className="flex flex-wrap items-center gap-2">
    <span className="flex items-center gap-1.5 text-[11px] font-bold uppercase tracking-[0.1em] text-slate-500">
      <CalendarRange size={13} /> Période
    </span>
    <input
      data-testid={`${testid}-du`}
      type="date"
      value={du}
      onChange={(e) => setDu(e.target.value)}
      className={cls}
      aria-label="Date de début"
    />
    <span className="font-data text-xs text-slate-400">→</span>
    <input
      data-testid={`${testid}-au`}
      type="date"
      value={au}
      onChange={(e) => setAu(e.target.value)}
      className={cls}
      aria-label="Date de fin"
    />
    {(du || au) && (
      <button
        type="button"
        data-testid={`${testid}-reset`}
        onClick={() => {
          setDu('');
          setAu('');
        }}
        className="flex h-10 items-center gap-1 border border-slate-300 px-2 text-xs font-semibold text-slate-600 transition-colors duration-150 hover:bg-slate-900 hover:text-white"
      >
        <X size={12} /> Effacer
      </button>
    )}
    {typeof filtres === 'number' && typeof total === 'number' && (du || au) && (
      <span data-testid={`${testid}-compteur`} className="font-data text-[11px] text-slate-500">
        {filtres} / {total} ligne(s)
      </span>
    )}
  </div>
);
